import type { ReactNode } from "react";

import { cn } from "@ui/lib/utils";

import { PILL_SHADOW } from "./types";

/**
 * White elevated rounded CTA — renders an <a> when given an href, otherwise a <button>.
 */
export function ElevatedButton({
  href,
  onClick,
  className,
  children,
}: {
  href?: string;
  onClick?: () => void;
  className?: string;
  children: ReactNode;
}) {
  const merged = cn(
    "tw-flex tw-h-11 tw-items-center tw-whitespace-nowrap tw-rounded-full tw-bg-white tw-px-5 tw-text-black tw-type-sm tw-outline-none tw-transition-colors hover:tw-bg-gray-100 focus-visible:tw-outline-focus",
    PILL_SHADOW,
    className,
  );

  return href ? (
    <a href={href} className={merged}>
      {children}
    </a>
  ) : (
    <button type='button' onClick={onClick} className={merged}>
      {children}
    </button>
  );
}
